// [Codex 2026-07-16] S139 keeps UI agent routing inside the Fintheon chat boundary.
export type FintheonAgentId = string;

/**
 * Map Fintheon UI agents to their Fintheon chat personas without importing backend types.
 */
export function toFintheonAgentOverride(
  fintheonAgentId: FintheonAgentId | undefined | null,
): string | undefined {
  if (!fintheonAgentId) return undefined;

  // [claude-code 2026-03-16] Agent roster v7.9: 5-agent mapping
  switch (fintheonAgentId) {
    case "harper":
      return "harper-cao";
    case "oracle":
      return "pma-merged";
    case "feucht":
      return "futures-desk";
    case "consul":
      return "fundamentals-desk";
    case "herald":
      return "herald";
    default:
      return undefined;
  }
}

export function fintheonConversationStorageKey(
  fintheonAgentId: FintheonAgentId | undefined | null,
  surfaceId?: string,
): string {
  const agent = fintheonAgentId ?? "default";

  return surfaceId
    ? `fintheon:conversation:${surfaceId}:${agent}`
    : `fintheon:conversation:${agent}`;
}
